/**
 * @author liyuan <yuankylee@163.com>
 * @desc for backend, change carefully
 * @date 2021/08/03
 */
export const HTTP_METHOD = {
  GET: 'GET',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
  TRACE: 'TRACE',
};

//Some common used http headers
export const HEADER = {
  CONTENT_TYPE: 'content-type',
};

//Some common used body content type
export const BODY_TYPE = {
  JSON: 'application/json',
  FORM_URL_ENCODED: 'application/x-www-form-urlencoded',
};

export const getResponseContentType = function (response) {
  if (!response || !response.headers) return;
  const headers = response.headers;
  if (typeof headers.get === 'function') {
    return headers.get(HEADER.CONTENT_TYPE);
  }
  return headers[HEADER.CONTENT_TYPE];
};

export const isJSONResponse = function (response) {
  const type = getResponseContentType(response);
  if (!type) return false;
  return type.indexOf(BODY_TYPE.JSON) >= 0;
};
